"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_view_1 = require("prosemirror-view");

var prosemirror_state_1 = require("prosemirror-state");

var prosemirror_utils_1 = require("prosemirror-utils");

var Node_1 = __importDefault(require("./Node"));

var TableCell = /*#__PURE__*/function (_Node_1$default) {
  _inherits(TableCell, _Node_1$default);

  var _super = _createSuper(TableCell);

  function TableCell() {
    _classCallCheck(this, TableCell);

    return _super.apply(this, arguments);
  }

  _createClass(TableCell, [{
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.renderContent(node);
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "td",
        getAttrs: function getAttrs(tok) {
          return {
            alignment: tok.info
          };
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "td";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: "paragraph+",
        tableRole: "cell",
        isolating: true,
        parseDOM: [{
          tag: "td"
        }],
        toDOM: function toDOM(node) {
          return ["td", node.attrs.alignment ? {
            style: "text-align: ".concat(node.attrs.alignment)
          } : {}, 0];
        },
        attrs: {
          colspan: {
            default: 1
          },
          rowspan: {
            default: 1
          },
          alignment: {
            default: null
          }
        }
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          decorations: function decorations(state) {
            var doc = state.doc,
                selection = state.selection;
            var decorations = [];
            var cells = prosemirror_utils_1.getCellsInColumn(0)(selection);

            if (cells) {
              cells.forEach(function (_ref, index) {
                var pos = _ref.pos;

                if (index === 0) {
                  decorations.push(prosemirror_view_1.Decoration.widget(pos + 1, function () {
                    var className = "grip-table";
                    var selected = prosemirror_utils_1.isTableSelected(selection);

                    if (selected) {
                      className += " selected";
                    }

                    var grip = document.createElement("a");
                    grip.className = className;
                    grip.addEventListener("mousedown", function (event) {
                      event.preventDefault();

                      _this.options.onSelectTable(state);
                    });
                    return grip;
                  }));
                }

                decorations.push(prosemirror_view_1.Decoration.widget(pos + 1, function () {
                  var rowSelected = prosemirror_utils_1.isRowSelected(index)(selection);
                  var className = "grip-row";

                  if (rowSelected) {
                    className += " selected";
                  }

                  if (index === 0) {
                    className += " first";
                  } else if (index === cells.length - 1) {
                    className += " last";
                  }

                  var grip = document.createElement("a");
                  grip.className = className;
                  grip.addEventListener("mousedown", function (event) {
                    event.preventDefault();

                    _this.options.onSelectRow(index, state);
                  });
                  return grip;
                }));
              });
            }

            return prosemirror_view_1.DecorationSet.create(doc, decorations);
          }
        }
      })];
    }
  }]);

  return TableCell;
}(Node_1.default);

exports.default = TableCell;